const styles = `:host{outline:0;align-items:center;padding:1.25rem 1rem .5rem;display:inline-flex}:host chameleon-typography{flex:1}`;export default styles;